function windowDataLayer(dataLayer) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayer)
}

const reportGA4 = ({event, customSection, customTitle}) => {
  windowDataLayer({
    'event': event ? event : 'click',
    'custom_section': customSection ? customSection : 'minha_claro_movel:fatura_facil',
    'custom_title': customTitle
  });
}

const reportPageViewGA4 = ({event = "pageview", customSection, customTitle}) => {
  reportGA4({ event, customSection, customTitle });
}

export { reportGA4,  reportPageViewGA4 }